import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export class BrokersPaths {
  static brokers = new EnhancedPath('/brokers');
}

const routesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: BrokersPaths.brokers.path,
      component: lazyWithRetry(() => import('app/pages/system/brokers')),
      pageCode: PAGE_CODES.BROKERS,
    },
  ],
};

export default routesConfig;
